
<template lang="pug">
.cost.whitespace-no-wrap.mr-4.flex.flex-wrap
  Icon(:item="item" size="sm")
  span.value.font-bold(:class="canAfford === undefined ? '' : (canAfford ? 'affordable' : 'not-affordable')") {{ Math.floor(amount) }}
</template>

<script>

// Resources are now managed by @vortex/engine via the adapter

export default {
  name: 'Resource',
  props: {
    item: { required: true },
    amount: { required: true },
    canAfford: { required: false }
  }
}
</script>

<style lang="scss" scoped>
.value {
  &.affordable {
    color: #71c327;

  &.not-affordable {
    color: #dc431f;


  }
  }
}</style>



// WEBPACK FOOTER //
// src/components/Resource.vue